import { CrudViewFormItemType } from '@rappider/rappider-components/utils';

export const DEFAULT_UI_DATA_SELECTOR = CrudViewFormItemType.TextBox;
